// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"yC","loaded":"yD","emblaSlide":"yE","arrowButton":"yF"};